var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-act-aqua-pipe",class:_vm.color},[_c('div',{staticClass:"temperature"},[_vm._v(_vm._s(_vm.formattedTemperature))]),_c('pipe-image'),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label || '\u00a0'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }